import getAllForms from "./getAllForms";
import getAllPrograms from "./getAllPrograms";
import addNewForm from "./addNewForm";
import getFormDetails from "./getFormDetails";
import changeFormStatus from "./changeFormStatus";
import editForm from "./editForm";
import updateFormFields from "./updateFormFields";
import useFormAsTemplate from "./useFormAsTemplate";
import deleteForm from "./deleteForm";
import archiveOrRestoreForm from "./archiveOrRestoreForm";
import getAllProgramsForForms from "./getAllProgramsForForms";
import getSurveyJsFormDetails from "./getSurveyJsFormDetails";
import exportForm from "./exportForm";
import exportFormTemplate from "./exportFormTemplate";
import formNameValidation from "./formNameValidation";
const Forms = {
  getAllForms,
  getAllPrograms,
  addNewForm,
  editForm,
  getFormDetails,
  changeFormStatus,
  useFormAsTemplate,
  updateFormFields,
  deleteForm,
  getAllProgramsForForms,
  archiveOrRestoreForm,
  getSurveyJsFormDetails,
  exportForm,
  exportFormTemplate,
  formNameValidation
};

export default Forms;
